import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import { createCustomizeLines, deleteCustomizeLines as _deleteCustomizeLines, deleteCustomizeLinesByIds, updateCustomizeLines, findCustomizeLines, getCustomizeLinesList } from "@/api/customizeLines"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
import { ipToInt, intToIp } from "@/utils/stringFun";
import { store } from '@/store/index';
export default {
  name: "CustomizeLines",
  mixins: [infoList],
  data: function data() {
    var _this = this;
    var checkIpsegName = function checkIpsegName(rule, value, callback) {
      var reg = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
      if (value === '') {
        callback(new Error(_this.$t('customize-line.check-error-empty-linename')));
      } else if (!reg.test(value)) {
        callback(new Error(_this.$t('customize-line.check-error-invalid-linename')));
      } else {
        callback();
      }
    };
    var checkIpseg = function checkIpseg(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('customize-line.check-error-empty-ipseg')));
        return false;
      }
      var reg = /^(((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}-((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}(;?)){1,100}$/;
      if (!reg.test(value)) {
        callback(new Error(_this.$t('customize-line.check-error-invalid-ipseg')));
        return false;
      }
      var ips = value.split(';');
      if (ips.length > 100) {
        callback(new Error(_this.$t('customize-line.check-error-count-ipseg')));
        return false;
      }
      var errs = [];
      var ipsegArr = [];
      ips.forEach(function (ipseg) {
        if (ipseg == '') {
          return true;
        }
        var arr = ipseg.split('-');
        var ipArr = [];
        ipArr[0] = ipToInt(arr[0]);
        ipArr[1] = ipToInt(arr[1]);
        if (ipArr[0] > ipArr[1]) {
          errs.push(ipseg + _this.$t('customize-line.check-error-cmp-ipseg'));
          return true;
        }
        if (ipArr[1] - ipArr[0] > 256) {
          errs.push(ipseg + _this.$t('customize-line.check-error-range-ipseg'));
          return true;
        }
        ipsegArr.push(ipArr);
      });

      // 排序
      ipsegArr.sort(function (a, b) {
        return a[0] - b[0];
      });
      ipsegArr.forEach(function (ipseg, idx, array) {
        if (idx != array.length - 1) {
          if (ipseg[1] >= array[idx + 1][0]) {
            errs.push(intToIp(ipseg[0]) + '-' + intToIp(ipseg[1]) + _this.$t('customize-line.and') + intToIp(array[idx + 1][0]) + '-' + intToIp(array[idx + 1][1]) + _this.$t('customize-line.check-error-Intersection-ipseg'));
          }
        }
      });
      if (errs.length > 0) {
        callback(new Error(errs.join(',')));
        return false;
      }
      callback();
    };
    return {
      listApi: getCustomizeLinesList,
      dialogFormVisible: false,
      type: "",
      deleteVisible: false,
      listAlias: 'customizelines',
      isDisabledSaveBtn: false,
      multipleSelection: [],
      formData: {
        ipseg: "",
        ipseg_name: ""
      },
      rules: {
        ipseg_name: [{
          required: true,
          message: this.$t('customize-line.check-error-empty-linename'),
          trigger: 'blur'
        }, {
          validator: checkIpsegName,
          trigger: 'blur'
        }, {
          min: 1,
          max: 17,
          message: this.$t('customize-line.check-error-count-linename'),
          trigger: 'blur'
        }],
        ipseg: [{
          required: true,
          message: this.$t('customize-line.check-error-empty-ipseg'),
          trigger: 'blur'
        }, {
          validator: checkIpseg,
          trigger: 'blur'
        }]
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    }
  },
  methods: {
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteRow: function deleteRow(row) {
      var _this2 = this;
      this.$confirm(this.$t('common.button.delete') + ' ' + row.ipseg_name + '?', this.$t('common.msg.prompt-title'), {
        confirmButtonText: this.$t('common.button.confirm'),
        cancelButtonText: this.$t('common.button.cancel'),
        type: 'warning'
      }).then(function () {
        row.zone = _this2.$route.query.zone;
        _this2.deleteCustomizeLines(row);
      });
    },
    onDelete: function onDelete() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ids, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = [];
              if (!(_this3.multipleSelection.length == 0)) {
                _context.next = 4;
                break;
              }
              _this3.$message({
                type: 'warning',
                message: _this3.$t('common.msg.delete-choose-warn')
              });
              return _context.abrupt("return");
            case 4:
              _this3.multipleSelection && _this3.multipleSelection.map(function (item) {
                ids.push(item.ID);
              });
              _context.next = 7;
              return deleteCustomizeLinesByIds({
                ids: ids
              });
            case 7:
              res = _context.sent;
              if (res.code == 0) {
                _this3.$message({
                  type: 'success',
                  message: _this3.$t('common.msg.delete-success')
                });
                if (_this3.tableData.length == ids.length) {
                  _this3.page--;
                }
                _this3.deleteVisible = false;
                _this3.getTableData();
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateCustomizeLines: function updateCustomizeLines(row) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var listName, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              listName = _this4.listAlias;
              _context2.next = 3;
              return findCustomizeLines({
                id: row.id,
                zone: _this4.$route.query.zone
              });
            case 3:
              res = _context2.sent;
              _this4.type = "update";
              if (res.code == 0) {
                _this4.formData = res.data[listName][0];
                _this4.dialogFormVisible = true;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.isDisabledSaveBtn = false;
      this.formData = {
        ipseg: "",
        ipseg_name: ""
      };
      this.$refs['formData'].resetFields();
    },
    deleteCustomizeLines: function deleteCustomizeLines(row) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _deleteCustomizeLines(row);
            case 2:
              res = _context3.sent;
              if (!(res.code == 0)) {
                _context3.next = 9;
                break;
              }
              _this5.$message({
                type: "success",
                message: _this5.$t('common.msg.delete-success')
              });
              if (_this5.tableData.length == 1) {
                _this5.page--;
              }
              _this5.getTableData();
              _context3.next = 9;
              return store.dispatch('viewinfo/updateRecordLines', _this5.$route.query.zone);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    enterDialog: function enterDialog(formName) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var isOk, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              isOk = true;
              _this6.$refs[formName].validate(function (valid) {
                if (!valid) {
                  isOk = false;
                  return false;
                }
              });
              if (isOk) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              _this6.isDisabledSaveBtn = true;
              _this6.formData.zone = _this6.$route.query.zone;
              _context4.t0 = _this6.type;
              _context4.next = _context4.t0 === "create" ? 9 : _context4.t0 === "update" ? 13 : 17;
              break;
            case 9:
              _context4.next = 11;
              return createCustomizeLines(_this6.formData);
            case 11:
              res = _context4.sent;
              return _context4.abrupt("break", 21);
            case 13:
              _context4.next = 15;
              return updateCustomizeLines(_this6.formData);
            case 15:
              res = _context4.sent;
              return _context4.abrupt("break", 21);
            case 17:
              _context4.next = 19;
              return createCustomizeLines(_this6.formData);
            case 19:
              res = _context4.sent;
              return _context4.abrupt("break", 21);
            case 21:
              if (!(res.code == 0)) {
                _context4.next = 29;
                break;
              }
              _this6.$message({
                type: "success",
                message: _this6.$t('common.msg.save-success')
              });
              _this6.closeDialog();
              _this6.getTableData();
              _context4.next = 27;
              return store.dispatch('viewinfo/updateRecordLines', _this6.$route.query.zone);
            case 27:
              _context4.next = 30;
              break;
            case 29:
              _this6.isDisabledSaveBtn = false;
            case 30:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openDialog: function openDialog() {
      this.type = "create";
      this.dialogFormVisible = true;
    }
  },
  created: function created() {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this7.searchInfo.zone = _this7.$route.query.zone;
            _context5.next = 3;
            return _this7.getTableData();
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};